import mainImg from "../../../assets/ss-soft-close-telescopic-slide.png";
import thumb1 from "../../../assets/ss-soft-close-telescopic-slide-thumb-one.webp";
import thumb2 from "../../../assets/ss-soft-close-telescopic-slide-thumb-two.webp";


import mainImg1 from "../../../assets/pocket-door -slide.webp";
import thumb3 from "../../../assets/pocket-door-slide-thumb-one.jpeg";
import thumb4 from "../../../assets/pocket-door-slide-thumb-two.jpeg";


import mainImg2 from "../../../assets/stainless-steel-telescopic-slide.webp";
import thumb5 from "../../../assets/stainless-steel-telescopic-slide-thumb-one.webp";
import thumb6 from "../../../assets/stainless-steel-telescopic-slide-thumb-two.webp";



import mainImg3 from "../../../assets/soft-close.webp";
import thumb7 from "../../../assets/soft-close-thumb-one.webp";
import thumb8 from "../../../assets/soft-close-thumb-two.webp";

import mainImg4 from "../../../assets/soft-close-telescopic-slide-black.webp";
import thumb9 from "../../../assets/soft-close-telescopic-slide-black.webp";
import thumb10 from "../../../assets/soft-close-telescopic-slide-black.webp";


import mainImg5 from "../../../assets/soft-close-telescopic-slide-zinc.webp";
import thumb11 from "../../../assets/soft-close-telescopic-slide-zinc.webp";
import thumb12 from "../../../assets/soft-close-telescopic-slide-zinc.webp";


export const telescopicChannels = [
  {
  code: "TC-01",
  name: "Stainless Steel Telescopic Slides - Slimline",
  category: "telescopic-channel",

  mainImage: mainImg,
  thumbnails: [thumb1, thumb2],

  // ✅ PRICE
  price: "₹738",
  oldPrice: "800",

  sku: "7037",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=SS%20Soft%20Closing%20Drawer%20Slide%20Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/Geh_nezYOlU",

  // ✅ DESCRIPTION
  short:
    "Stainless Steel Telescopic Slides  are crafted from premium stainless steel for smooth, silent, and durable performance. The inbuilt soft-close mechanism prevents slamming and ensures controlled closing. Corrosion-resistant and strong, these slides are ideal for kitchens, wardrobes, and offices.",

  // ✅ FEATURES
  features: [
    "Stainless steel body",
    "Soft-close mechanism",
    "Smooth sliding",
    "High load capacity",
    "Long-lasting durability"
  ],

  // ✅ SPECIFICATIONS (optional but useful for your UI consistency)
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Mechanism", value: "Soft Close" },
    { label: "Usage", value: "Kitchen, Wardrobe, Office Drawers" },
    { label: "Finish", value: "Silver" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Stainless Steel Telescopic Slides",
      code: "7037",
      size: "500mm x (20\")",
      finish: "SS"
    },
    {
      item: "Stainless Steel Telescopic Slides",
      code: "7036",
      size: "450mm x (18\")",
      finish: "SS"
    },
    {
      item: "Stainless Steel Telescopic Slides",
      code: "7035",
      size: "400mm x (16\")",
      finish: "SS"
    },
    {
      item: "Stainless Steel Telescopic Slides",
      code: "7034",
      size: "350mm x (14\")",
      finish: "SS"
    },
    {
      item: "Stainless Steel Telescopic Slides",
      code: "7033",
      size: "300mm x (12\")",
      finish: "SS"
    },
    {
      item: "Stainless Steel Telescopic Slides",
      code: "074",
      size: "250mm x (10\")",
      finish: "SS"
    },
    {
      item: "Stainless Steel Telescopic Slides",
      code: "7031",
      size: "600mm x (24\")",
      finish: "SS"
    },
    {
      item: "Stainless Steel Telescopic Slides",
      code: "7038",
      size: "550mm x (22\")",
      finish: "SS"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a SS Soft Closing Drawer Slide – Slimline?",
      answer:
        "It is a stainless steel drawer slide mechanism that ensures smooth and silent closing of drawers in modular kitchens or furniture."
    },
    {
      question: "Where is it used?",
      answer:
        "It is commonly installed in kitchen drawers, wardrobes, and modular furniture."
    },
    {
      question: "What are its advantages?",
      answer:
        "It prevents slamming, ensures smooth movement, and increases drawer life."
    },
    {
      question: "What can be stored in drawers?",
      answer:
        "Utensils, cutlery, clothes, tools, and household items."
    }
  ]
},


   {
  code: "TC-02",
  name: "POCKET DOOR SLIDE",
  category: "telescopic-channel",

  // MAIN IMAGE
  mainImage: mainImg1,

  // THUMBNAILS
  thumbnails: [thumb3, thumb4],

  // PRICE
  price: "₹360",
  oldPrice: "400",

  sku: "7757",
  stock: "In Stock",

  // LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Pocket%20Door%20Slide%20Inquiry",

  // VIDEO (optional)
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // DESCRIPTION
  short:
    "Pocket Door Slide is a modern sliding hardware system that allows the door to glide smoothly inside the wall. It is a space-saving solution, perfect for small rooms, offices, and modular interiors. Its smooth roller mechanism ensures silent and effortless movement. With strong metal construction, it offers long-lasting durability and reliable performance.",

  // FEATURES
  features: [
    "Smooth & Silent Sliding",
    "Space Saving Design",
    "Heavy Duty Roller Mechanism",
    "Strong & Durable Material",
    "Ideal for Home & Office Use"
  ],

  // SPECIFICATIONS
  specifications: [
    { label: "Material", value: "High Grade Metal" },
    { label: "Mechanism", value: "Sliding Pocket System" },
    { label: "Usage", value: "Doors, Cabinets, Modular Interiors" },
    { label: "Finish", value: "SS / Powder Coated" }
  ],

  // SPEC TABLE
  specTable: [
     {
      item: "POCKET DOOR SLIDE",
      code: "7757",
      size: "200mm (10\")",
      finish: "BLACK"
    },
    {
      item: "POCKET DOOR SLIDE",
      code: "7758",
      size: "300mm (12\")",
      finish: "BLACK"
    },
    {
      item: "POCKET DOOR SLIDE",
      code: "7759",
      size: "350mm (14\")",
      finish: "BLACK"
    },
    {
      item: "POCKET DOOR SLIDE",
      code: "7760",
      size: "400mm (16\")",
      finish: "BLACK"
    },
    {
      item: "POCKET DOOR SLIDE",
      code: "7761",
      size: "450mm (18\")",
      finish: "BLACK"
    },
    {
      item: "POCKET DOOR SLIDE",
      code: "7762",
      size: "500mm (20\")",
      finish: "BLACK"
    },
  ],

  // FAQ
  faq: [
    {
      question: "What is a Pocket Door Slide?",
      answer:
        "Pocket Door Slide is a sliding door mechanism that allows a door to slide into a concealed cavity within the wall, saving space and providing a clean look."
    },
    {
      question: "Where is the Pocket Door Slide used?",
      answer:
        "It is commonly used in kitchens, bathrooms, wardrobes, and modern interiors where space-saving is required."
    },
    {
      question: "What are the advantages of a Pocket Door Slide?",
      answer:
        "It saves space, provides smooth sliding, improves aesthetics, and allows hidden door movement."
    },
    {
      question: "What items can be used with it?",
      answer:
        "It is used for doors, cabinets, and partitions in compact areas."
    }
  ]
},


  {
  code: "TC-03",
  name: "STAINLESS STEEL TELESCOPIC SLIDES PRIME",
  category: "telescopic-channel",

  // MAIN IMAGE
  mainImage: mainImg2,

  // THUMBNAILS
  thumbnails: [thumb5, thumb6],

  // PRICE
  price: "₹369",
  oldPrice: "500",

  sku: "7146",
  stock: "In Stock",

  // LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Telescopic%20Slides%20Prime%20Inquiry",

  // VIDEO (optional)
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // DESCRIPTION
  short:
    "Stainless Steel Telescopic Slides – Prime Series are high-performance drawer slides designed for smooth, silent, and long-lasting movement. Made from premium-grade stainless steel, these slides are corrosion-resistant, making them ideal for kitchens, office furniture, and heavy-duty applications. Their precision ball-bearing mechanism ensures effortless sliding, allowing drawers to open and close smoothly without jamming. With strong load capacity and durable construction, they are a reliable choice for modern interiors.",

  // FEATURES
  features: [
    "Stainless Steel Body – Rust resistant",
    "Smooth Ball Bearing Movement",
    "Silent & Effortless Sliding",
    "High load capacity",
    "Full Extension Opening"
  ],

  // SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Mechanism", value: "Ball Bearing System" },
    { label: "Usage", value: "Kitchen, Office, Modular Furniture" },
    { label: "Finish", value: " Zinc Finish" }
  ],

  // SPEC TABLE (SIZE FORMAT INCLUDED LIKE YOUR STYLE)
  specTable: [
    {
      item: "Stainless Steel Telescopic Slides Prime",
      code: "7146",
      size: "500mm (20\")",
      finish: "ZINC"
    },
    {
      item: "Stainless Steel Telescopic Slides Prime",
      code: "7145",
      size: "450mm (18\")",
      finish: "ZINC"
    },
    {
      item: "Stainless Steel Telescopic Slides Prime",
      code: "7144",
      size: "400mm (16\")",
      finish: "ZINC"
    },
    {
      item: "Stainless Steel Telescopic Slides Prime",
      code: "7143",
      size: "350mm (14\")",
      finish: "ZINC"
    },
    {
      item: "Stainless Steel Telescopic Slides Prime",
      code: "7142",
      size: "300mm (12\")",
      finish: "ZINC"
    },
    {
      item: "Stainless Steel Telescopic Slides Prime",
      code: "7141",
      size: "250mm (10\")",
      finish: "ZINC"
    },
    {
      item: "Stainless Steel Telescopic Slides Prime",
      code: "7235",
      size: "200mm (8\")",
      finish: "ZINC"
    },
    {
      item: "Stainless Steel Telescopic Slides Prime",
      code: "7147",
      size: "550mm (22\")",
      finish: "ZINC"
    },
    {
      item: "Stainless Steel Telescopic Slides Prime",
      code: "7148",
      size: "600mm (24\")",
      finish: "ZINC"
    }
  ],

  // FAQ
  faq: [
    {
      question: "What is a Stainless Steel Telescopic Slides Prime?",
      answer:
        "It is a high-quality stainless steel drawer slide system designed for smooth and full extension movement of drawers."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen drawers, wardrobes, office furniture, and modular storage systems."
    },
    {
      question: "What are its advantages?",
      answer:
        "It offers smooth sliding, high load capacity, corrosion resistance, and long durability."
    },
    {
      question: "What can be stored in drawers using it?",
      answer:
        "Utensils, clothes, office items, tools, and other household or commercial items."
    }
  ]
},


  {
  code: "TC-04",
  name: "SOFT CLOSE DRAWER SLIDE",
  category: "telescopic-channel",

  // MAIN IMAGE
  mainImage: mainImg3,

  // THUMBNAILS
  thumbnails: [thumb7, thumb8],

  // PRICE
  price: "₹705",
  oldPrice: "800",

  sku: "7030",
  stock: "In Stock",

  // LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Soft%20Close%20Drawer%20Slide%20Inquiry",

  // VIDEO (optional)
  video: "https://www.youtube.com/embed/H0yeTcQxsUM",

  // DESCRIPTION
  short:
    "Soft Close Drawer Slides are advanced drawer channels designed to provide smooth, silent, and controlled closing. These slides prevent slamming by using an inbuilt hydraulic soft-close mechanism, ensuring durability, safety, and a premium user experience. Ideal for modular kitchens, wardrobes, and office furniture, they enhance convenience and extend the life of drawers.",

  // FEATURES
  features: [
    "Stainless Steel Body – Rust resistant",
    "Soft Close Hydraulic Mechanism",
    "Smooth Ball Bearing Movement",
    "Silent & Controlled Closing",
    "High load capacity",
    "Full Extension Opening"
  ],

  // SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Stainless Steel / Mild Steel" },
    { label: "Mechanism", value: "Soft Close Hydraulic System" },
    { label: "Usage", value: "Kitchen, Wardrobe, Office Furniture" },
    { label: "Finish", value: "Zinc Finish" }
  ],

  // SPEC TABLE (SIZE FORMAT ADDED LIKE YOUR STYLE)
  specTable: [
    
    {
      item: "Soft Close Drawer Slide",
      code: "7030",
      size: "500mm (20\")",
      finish: "SS"
    },
    {
      item: "Soft Close Drawer Slide",
      code: "7029",
      size: "450mm (18\")",
      finish: "SS"
    },
    {
      item: "Soft Close Drawer Slide",
      code: "7028",
      size: "400mm (16\")",
      finish: "SS"
    },
    {
      item: "Soft Close Drawer Slide",
      code: "7027",
      size: "350mm (14\")",
      finish: "SS"
    },
    {
      item: "Soft Close Drawer Slide",
      code: "7026",
      size: "300mm (12\")",
      finish: "SS"
    }
  ],

  // FAQ
  faq: [
    {
      question: "What is a Soft Close Drawer Slide?",
      answer:
        "It is a drawer slide system that allows drawers to close gently and silently using a hydraulic mechanism."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen drawers, wardrobes, office furniture, and modular cabinets."
    },
    {
      question: "What are its advantages?",
      answer:
        "It prevents slamming, increases durability, provides smooth movement, and improves safety."
    },
    {
      question: "What can be stored in drawers?",
      answer:
        "Utensils, clothes, tools, office items, and household accessories can be safely stored."
    }
  ]
},


  {
  code: "TC-05",
  name: "SOFT CLOSE TELESCOPIC SLIDES - BLACK",
  category: "telescopic-channel",

  // MAIN IMAGE
  mainImage: mainImg4,

  // THUMBNAILS
  thumbnails: [thumb9, thumb10],

  // PRICE
  price: "₹537",
  oldPrice: "600",

  sku: "7409",
  stock: "In Stock",

  // LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Soft%20Close%20Telescopic%20Slides%20Black%20Inquiry",

  // VIDEO (optional)
  video:"https://www.youtube.com/embed/C2G7hQ3Yx3I",

  // DESCRIPTION
  short:
    "Soft Close Telescopic Slides Black are premium drawer slides designed to provide smooth, quiet, and controlled drawer movement. Featuring a soft-close mechanism, they ensure that drawers close gently without slamming. With a durable black finish and strong telescopic design, these slides offer full extension and reliable performance, making them ideal for modular kitchens, wardrobes, and furniture drawers.",

  // FEATURES
  features: [
    "Soft close mechanism for smooth and silent drawer closing",
    "Telescopic design for full drawer extension",
    "Durable black finish for a modern and stylish look",
    "Strong load-bearing capacity for daily use",
    "Ideal for modular kitchens, wardrobes, and furniture drawers",
    "Smooth sliding operation with long-lasting performance"
  ],

  // SPECIFICATIONS
  specifications: [
    { label: "Material", value: "High Strength Steel" },
    { label: "Mechanism", value: "Soft Close Telescopic System" },
    { label: "Usage", value: "Kitchen, Wardrobe, Furniture Drawers" },
    { label: "Finish", value: "Black Powder Coated" }
  ],

  // SPEC TABLE (SIZE FORMAT ADDED)
  specTable: [
    
    {
      item: "Soft Close Telescopic Slide Black",
      code: "7409",
      size: "500mm (20\")",
      finish: "Black"
    },
    {
      item: "Soft Close Telescopic Slide Black",
      code: "7408",
      size: "450mm (18\")",
      finish: "Black"
    },
    {
      item: "Soft Close Telescopic Slide Black",
      code: "7407",
      size: "400mm (16\")",
      finish: "Black"
    },
    {
      item: "Soft Close Telescopic Slide Black",
      code: "7406",
      size: "350mm (14\")",
      finish: "Black"
    },
    {
      item: "Soft Close Telescopic Slide Black",
      code: "7405",
      size: "300mm (12\")",
      finish: "Black"
    }
  ],

  // FAQ
  faq: [
    {
      question: "What are Soft Close Telescopic Slides Black?",
      answer:
        "They are drawer slides with a soft-close mechanism that ensures smooth, silent, and controlled closing of drawers."
    },
    {
      question: "Where are they used?",
      answer:
        "They are used in modular kitchens, wardrobes, office furniture, and storage drawers."
    },
    {
      question: "What is the benefit of soft close?",
      answer:
        "It prevents slamming, reduces noise, and increases the life of drawers."
    },
    {
      question: "Do they support full extension?",
      answer:
        "Yes, the telescopic system allows full extension for easy access."
    },
    {
      question: "Are they durable?",
      answer:
        "Yes, they come with a strong build and black powder-coated finish for long-lasting use."
    }
  ]
},

  {
  code: "TC-06",
  name: "SLIMLINE SERIES - TELESCOPIC SLIDES - ZINC",
  category: "telescopic-channel",

  // MAIN IMAGE
  mainImage: mainImg5,

  // THUMBNAILS
  thumbnails: [thumb11, thumb12],

  // PRICE
  price: "₹411",
  oldPrice: "500",

  sku: "7014",
  stock: "In Stock",

  // LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Soft%20Close%20Telescopic%20Slides%20Zinc%20Inquiry",

  // VIDEO (optional)
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // DESCRIPTION
  short:
    " Telescopic Slides – Zinc are high-quality drawer slides designed for smooth, quiet, and controlled drawer movement. Equipped with a soft-close mechanism, they allow drawers to close gently without slamming. The durable zinc finish provides excellent strength and corrosion resistance, making these slides ideal for modular kitchens, wardrobes, and furniture drawers.",

  // FEATURES
  features: [
    " mechanism for smooth and silent drawer closing",
    "Telescopic design allows full drawer extension",
    "Durable zinc finish for strength and corrosion resistance",
    "Strong load-bearing capacity for daily use",
    "Ideal for modular kitchens, wardrobes, and furniture drawers",
    "Smooth sliding performance with long-lasting durability"
  ],

  // SPECIFICATIONS
  specifications: [
    { label: "Material", value: "High Strength Steel" },
    { label: "Mechanism", value: "Soft Close Telescopic System" },
    { label: "Usage", value: "Kitchen, Wardrobe, Furniture Drawers" },
    { label: "Finish", value: "Zinc Coated" }
  ],

  // SPEC TABLE (SIZE FORMAT ADDED)
  specTable: [
    
    {
      item: "Soft Close Telescopic Slide Zinc",
      code: "7014",
      size: "500mm (20\")",
      finish: "Zinc"
    },
    {
      item: "Soft Close Telescopic Slide Zinc",
      code: "7013",
      size: "450mm (18\")",
      finish: "Zinc"
    },
    {
      item: "Soft Close Telescopic Slide Zinc",
      code: "7012",
      size: "400mm (16\")",
      finish: "Zinc"
    },
    {
      item: "Soft Close Telescopic Slide Zinc",
      code: "7011",
      size: "350mm (14\")",
      finish: "Zinc"
    },
    {
      item: "Soft Close Telescopic Slide Zinc",
      code: "7010",
      size: "300mm (12\")",
      finish: "Zinc"
    },
    {
      item: "Soft Close Telescopic Slide Zinc",
      code: "7009",
      size: "250mm (10\")",
      finish: "Zinc"
    },
    {
      item: "Soft Close Telescopic Slide Zinc",
      code: "7008",
      size: "200mm (8\")",
      finish: "Zinc"
    },
    {
      item: "Soft Close Telescopic Slide Zinc",
      code: "7015",
      size: "550mm (22\")",
      finish: "Zinc"
    },
    {
      item: "Soft Close Telescopic Slide Zinc",
      code: "7016",
      size: "600mm (24\")",
      finish: "Zinc"
    },
  ],

  // FAQ
  faq: [
    {
      question: "What are Soft Close Telescopic Slides – Zinc?",
      answer:
        "They are drawer slides with a soft-close mechanism that ensures smooth, silent, and controlled drawer closing."
    },
    {
      question: "Where are they used?",
      answer:
        "They are used in modular kitchens, wardrobes, office furniture, and storage drawers."
    },
    {
      question: "What is the benefit of soft close?",
      answer:
        "It prevents slamming, reduces noise, and increases the life of drawers."
    },
    {
      question: "Is zinc finish durable?",
      answer:
        "Yes, zinc coating provides strong corrosion resistance and long-lasting performance."
    }
  ]
}
];
